import React from "react";

//context
import { UserContextWrapper } from "./context/UserContext";
import { ContextWrapper } from "./context/ContextWrapper";

//components
import Contest from "./components/questionaire/Contest";

const App = ({
    user,
    variant,
    description,
    background,
    color,
    end,
    endPageContent,
    pageID,
    pageAfterQuestions,
}) => {
    return (
        <UserContextWrapper user={user}>
            <ContextWrapper>
                <div
                    className="App"
                    style={{ background: background, color: color }}
                >
                    <Contest
                        endPageContent={endPageContent}
                        color={color}
                        background={background}
                        description={description}
                        pageID={pageID}
                        pageAfterQuestions={pageAfterQuestions}
                    />
                </div>
            </ContextWrapper>
        </UserContextWrapper>
    );
};

export default App;
